export const accentColorMapping: Record<string, string> = {
	'var(--color-5)': 'var(--accent-color-5)',
	'var(--color-6)': 'var(--accent-color-6)',
	'var(--color-7)': 'var(--accent-color-7)',
	'var(--color-8)': 'var(--accent-color-8)',
	'var(--color-9)': 'var(--accent-color-9)',
}